import {createRouter, createWebHistory} from "vue-router"

import Body from '../components/body';
import Default from '../pages/dashboard/main.vue';
import login from '../pages/login.vue';

import reportsRoutes from './reports'
import toolsRoutes from './tools'
import userRoutes from './users.js'
import childrenRoutes from './children'
import assessmentsRoutes from './assessments'
import interventionsRoutes from './interventions'
import materialsRoutes from './materials'
import rolesRoutes from './roles'
import faqsRoutes from './faqs'
import subscriptionsRoutes from './subscriptions'
import feebacksRoutes from './feebacks'
import settingsRoutes from './settings'
import paymentsRoutes from './payments'

// import createIntervention from '../pages/assessment/createIntervention.vue';
import activityHome from '../pages/activity/index.vue';
import supportTickets from "@/pages/tickets/index.vue";
import editTicket from "@/pages/tickets/ticket.vue";
import forumLanding from "@/pages/forum_landing.vue";

const routes =[
  {
    path: '/',
    component: Body,
    children: [
      ...userRoutes,
      ...assessmentsRoutes,
      ...interventionsRoutes,
      ...materialsRoutes,
      ...reportsRoutes,
      ...rolesRoutes,
      ...faqsRoutes,
      ...subscriptionsRoutes,
      ...settingsRoutes,
      ...feebacksRoutes,
      ...childrenRoutes,
      ...toolsRoutes,
      ...paymentsRoutes,
      {
        path: '',
        redirect: '/dashboard'
      },
      { // /forum
        path: '/forum',
        name: 'forum',
        component: forumLanding,
        meta:{
          name: 'Forum',
          requireAuth: true
        },
      },
      { // /dashboard
        path: '/dashboard',
        name: 'dashboard',
        component: Default,
        meta:{
          name: 'Dashboard',
          requireAuth: true
        },
      },
      { // activity
        path: 'activity',
        name: 'activity',
        component: activityHome,
        meta:{
          name: 'Activity',
          requireAuth: true
        },
      },
      { // support
        path: 'support',
        name: 'support',
        component: supportTickets,
        meta:{
          name: 'Support',
          requireAuth: true
        },
      },
      { // support/:id
        path: 'support/:id',
        name: 'support-view',
        component: editTicket,
        meta:{
          name: 'View Ticket',
          requireAuth: true
        },
      },
      {
        path: '/unauthorized',
        name: 'unauthorized',
        component: () => import('../pages/error/Unauthorized.vue'),
        meta:{
          name: 'Unauthorized',
          requireAuth: true
        }
      },
      {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('../pages/error/NotFound.vue'),
        meta: {
          name: 'Page Not Found',
          requireAuth: true
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    meta:{
      name: 'Login',
      requireAuth: false
    }
  }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && to.meta.requireAuth && localStorage.getItem('uid') === null){
    next({name: 'login'})
  }else{
    document.title = to.meta.name + ' | CareXera Admin'
    next()
  }
});
export default router